// JsFromRoutes CacheKey 2a20e894da6f9dddf0280a13a42921fb
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/consumer/gift_lists'),
  create: /* #__PURE__ */ definePathHelper('post', '/consumer/gift_lists'),
  update: /* #__PURE__ */ definePathHelper('patch', '/consumer/gift_lists/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/consumer/gift_lists/:id'),
}
